import { createRouter, createWebHistory } from "vue-router";
import store from "@/store/index";
import { ElMessage } from "element-plus";

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/Home/index.vue"),
    meta: { navFlag: true },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/Login/index.vue"),
  },
  {
    path: "/search",
    name: "search",
    component: () => import("@/views/Search/index.vue"),
  },
  {
    path: "/product-list",
    name: "product-list",
    component: () => import("@/views/Product-list/index.vue"),
  },
  {
    path: "/product-item",
    name: "product-item",
    component: () => import("@/views/Product-item/index.vue"),
  },
  {
    path: "/cart",
    name: "cart",
    component: () => import("@/views/Cart/index.vue"),
  },
  {
    path: "/checkout",
    name: "checkout",
    component: () => import("@/views/Checkout/index.vue"),
  },
  {
    path: "/pay",
    name: "pay",
    component: () => import("@/views/Pay/index.vue"),
  },
  {
    path: "/account",
    name: "account",
    component: () => import("@/views/Account/index.vue"),
    children: [
      {
        path: "/account/order-list",
        name: "order-list",
        component: () => import("@/views/Account/order-list.vue"),
      },
      {
        path: "/account/order-item",
        name: "order-item",
        component: () => import("@/views/Account/order-item.vue"),
      },
      {
        path: "/account",
        redirect: {
          path: "/account/order-list",
        },
      },
    ],
  },
  {
    path: "/vip-membership",
    name: "vip-membership",
    component: () => import("@/views/Account/vip-membership.vue"),
  },
  {
    path: "/checkoutnow",
    name: "checkoutnow",
    component: () => import("@/views/checkoutnow.vue"),
  },
  {
    path: "/webapps/billing/subscriptions",
    name: "subscriptions",
    component: () => import("@/views/subscriptions.vue"),
  },
  {
    path: "/contact-us",
    name: "contact-us",
    component: () => import("@/views/Account/contact-us.vue"),
  },
  {
    path: "/about-us",
    name: "about-us",
    component: () => import("@/views/Account/about-us.vue"),
  },
  {
    path: "/terms-conditions",
    name: "terms-conditions",
    component: () => import("@/views/Account/foot/terms-conditions.vue"),
  },
  {
    path: "/refund-policy",
    name: "refund-policy",
    component: () => import("@/views/Account/foot/refund-policy.vue"),
  },
  {
    path: "/privacy-policy",
    name: "privacy-policy",
    component: () => import("@/views/Account/foot/privacy-policy.vue"),
  },
  {
    path: "/shipping-delivery",
    name: "shipping-delivery",
    component: () => import("@/views/Account/foot/shipping-delivery.vue"),
  },
  // 404 页面
  {
    path: "/:catchAll(.*)",
    name: "NotFound",
    component: () => import("@/views/404.vue"),
  },
  {
    // 路由重定向
    path: "/",
    redirect: {
      path: "/",
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  // 每次路由跳转之后 新页面加载在x轴和y轴的初始位置
  scrollBehavior() {
    return {
      left: 0,
      top: 0,
    };
  },
});

// 全局前置守卫
router.beforeEach((to, from, next) => {
  if (to.path === "/checkout" && !store.state.userInfo.access_token) {
    next("/login");
  } else if (to.path === "/pay" && !store.state.userInfo.access_token) {
    next("/login");
  } else if (
    to.path === "/account/order-list" &&
    !store.state.userInfo.access_token
  ) {
    next("/login");
  } else {
    next();
  }
  next();
});

export default router;
